import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gd-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.less']
})
export class SuccessModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
